import PageHeader from 'components/Admin/Shared/PageHeader'
import { Tab, Tabs } from 'components/Tabs'
import { NavLink as RouterLink, useNavigate } from 'react-router-dom'
import style from './style.module.scss'
import { useState } from 'react'
import AssignManagerModal from 'components/Admin/Shared/Dashboard/AssignManagerModal'
import { Role } from 'types'
import { Button, Icon } from '@crossfit/ui'
import TeammatesTable from 'components/Admin/Shared/TeammatesTable'
import InvitationsTable from 'components/Admin/Shared/Dashboard/InvitationsTable'
import { useAffiliate } from 'hooks/useAffiliate'

export interface StaffProps {
  staffType: 'active' | 'pending'
}

export default function Staff(props: StaffProps) {
  const {
    selectedAffiliate: affiliate,
    invitations,
    canInvite,
  } = useAffiliate()
  const [showAssignManager, setShowAssignManager] = useState(false)
  const navigate = useNavigate()

  return (
    <>
      <PageHeader
        title={'COACHES & STAFF'}
        hideLinks={true}
        showStaffDescription
      />
      <section className={style.wrapper}>
        <header className={style.header}>
          <Tabs>
            <Tab as={RouterLink} to='/admin/staff' end>
              {affiliate.members.length
                ? `Active (${affiliate.members.length})`
                : 'No Active Teammates'}
            </Tab>
            {canInvite && (
              <Tab as={RouterLink} to='/admin/staff/pending' end>
                Pending ({invitations.length})
              </Tab>
            )}
          </Tabs>
          {canInvite && (
            <div className={style.actionButtonContainer}>
              <Button
                variant='secondary'
                className={style.actionButton}
                onClick={() => {
                  setShowAssignManager(true)
                }}
              >
                ASSIGN MANAGER
              </Button>
              <Button
                variant='primary'
                rightIcon={<Icon name='arrow-right' />}
                className={style.actionButton}
                onClick={() => {
                  navigate('/admin/staff/invite')
                }}
              >
                INVITE
              </Button>
            </div>
          )}
        </header>
        {props.staffType === 'active' ? (
          <TeammatesTable teammates={affiliate.members} />
        ) : (
          <InvitationsTable />
        )}
      </section>

      {showAssignManager && (
        <AssignManagerModal
          onClose={() => setShowAssignManager(false)}
          teammates={affiliate.members.filter((teammate) =>
            teammate.roles.includes(Role.Coach),
          )}
          affiliate={affiliate}
        />
      )}
    </>
  )
}
